module.exports = __webpack_public_path__ + "static/media/cert_118.b75abd1c.jpg";